import React, { Component } from "react";
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import LoadingOverlay from 'react-loading-overlay';
import Timer from 'otp-timer'
import Logo from '../../images/1.png'
import { authHeader } from "../../_helpers";
import { CONST } from "../../_config";
import { FaHome } from "react-icons/fa";
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { Link } from "react-router-dom";
class Login extends Component {
  constructor(props) {
    super(props);
    this.loginSubmit = this.loginSubmit.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.state = {
      fieldslogin: {},
      errorslogin: {},
      otpSentLogin: false,
      passwordVisible: false,

    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {

    if (nextProps.otpSentLogin) {
      return {
        ...nextProps,
        otpSentLogin: nextProps.otpSentLogin ? nextProps.otpSentLogin : false

      }
    } else {
      return {
        ...nextProps
      }
    }
  }


  inputChange(e) {
    e.preventDefault();
    let { name, value } = e.target;
    this.setState({ [name]: value });
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = this.state.errorslogin;
    fieldslogin[name] = value;
    errorslogin[name] = "";
    this.setState({ fieldslogin, errorslogin });
  }


  loginSubmit(e) {
    e.preventDefault();
    if (this.handleValidationLogin()) {
      let { userName, password, } = this.state;
      this.props.dispatch(userActions.login({ email: userName, password: password, }, this.props));
    }

  }

  resendSubmit = (e) => {
    if (this.handleValidationLogin()) {
      let { userName, password, } = this.state;
      this.props.dispatch(userActions.login({ userName: userName, password: password, }, this.props));
    }

  }

  resetForm = (e) => {
    e.preventDefault();
    this.setState({
      fieldslogin: {},
      errorslogin: {},
    })
    this.hideErrorMessage();
  }


  handleValidationLogin = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    if (!fieldslogin["userName"]) {
      formIsValid = false;
      errorslogin["userName"] = "Email is required!";
    } else if (!/\S+@\S+\.\S+/.test(fieldslogin["userName"])) {
      formIsValid = false;
      errorslogin["userName"] = "Invalid Email address!";
    }



    //Password
    if (!fieldslogin["password"]) {
      formIsValid = false;
      errorslogin["password"] = "Please Enter Password!";
    }
    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }

  componentDidMount() {
    this.props.dispatch(userActions.resetdata())

  }

  onClickMenu = (url) => {
    this.props.history.push(url)
  }

  otpSubmit = (e) => {
    e.preventDefault();
    if (this.handleValidationOTP()) {

      let { userToken } = this.props.registeruser;
      let { OTP } = this.state;
      console.log(userToken, OTP)
      this.props.dispatch(userActions.validateLoginOtp({
        token: userToken,
        otp: OTP
      }, this.props));
    }
  }

  handleValidationOTP = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //Name
    if (!fieldslogin["OTP"]) {
      formIsValid = false;
      errorslogin["OTP"] = "please enter OTP!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible
    }));
  };

  render() {
    let { loading } = this.props;
    const { errorslogin, passwordVisible } = this.state;

    return (
      <>

        <div>
          <LoadingOverlay
            active={loading}
            className="temp001"
            spinner
            text='Please wait...' />
        </div>

        <>

          {/* Whole Structure */}
          <div className="overflow-y-hidden">
            {/*Header Section */}
            <div className="bg-cover bg-no-repeat overflow-y-hidden h-screen bg-[#95CCC5]"
            >
              <div className="h-screen flex flex-col justify-center py-8 px-3 sm:px-6 lg:px-8 z-20  overflow-y-auto">
                <div className="mx-auto w-full  max-w-lg">
                  <div className="bg-dark bg-slate-300 relative border border-gray-800 py-16 shadow rounded-3xl px-6 sm:px-12 z-20">
                    <Link to="/" className=" absolute top-3 left-5 text-xl text-[#005F60] cursor-pointer" >

                      <FaHome />
                    </Link>

                    <div className="justify-between lg:flex py-4 space-y-2 lg:space-x-2 space-x-0 lg:space-y-0">
                      <button className=" w-full py-3 px-1 bg-[#ED117F] text-white rounded-md capitalize text-sm  font-bold">Login as physio</button>
                      <button onClick={() => this.onClickMenu('/hospital/login')} className=" w-full py-3 px-1 bg-white text-[#005F60] rounded-md capitalize text-sm  font-bold">Login as Hospital / Clinic</button>

                    </div>

                    <form autoComplete="off" className="space-y-4">

                      <div className="space-y-1">
                        <label className="text-[#005F60] font-bold text-sm">Email</label>
                        <div className="rounded-md shadow-sm relative">
                          <input className={`appearance-none block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["userName"] ? "'border-opacity-20 border-opacity-100 border placeholder-gray-700" : "border-opacity-100 border border-red-500"}`}
                            id="userName" name="userName" placeholder="Email" type="userName" onChange={this.inputChange} />
                          {this.state.errorslogin["userName"] ?
                            <div className="invalid-feedback text-[#005F60]">
                              {this.state.errorslogin["userName"]}
                            </div>
                            : null}
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#005F60] font-bold  text-sm">Password</label>
                        <div className="rounded-md shadow-sm relative">
                          <input
                            className={`appearance-none block w-full px-4 py-4 rounded-xl text-gray-800 bg-gray-50 focus:outline-none focus:border-gray-200 focus:bg-gray-100 focus:text-gray-800 transition duration-150 ease-in-out text-lg font-normal sm:leading-5 ${!this.state.errorslogin["password"]
                              ? " border-opacity-100 border placeholder-gray-700"
                              : "border-opacity-100 border border-red-500 bg-dark-400"
                              }`}
                            id="password"
                            name="password"
                            placeholder="Password"
                            type={passwordVisible ? "text" : "password"}
                            onChange={this.inputChange}
                          />
                          {this.state.errorslogin["password"] ? (
                            <div className="invalid-feedback text-[#005F60]">
                              {this.state.errorslogin["password"]}
                            </div>
                          ) : null}
                          <span className="absolute top-5 right-5 text-gray-400 cursor-pointer" onClick={this.togglePasswordVisibility}>
                            {passwordVisible ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                          </span>
                        </div>
                      </div>


                      <div className="text-sm text-end justify-end items-end flex">
                        <span className="cursor-pointer font-bold text-[#005F60]  hover:text-green-600 hover:underline focus:outline-none focus:underline transition ease-in-out duration-150 ml-0" onClick={() => this.onClickMenu('/physio/forgot')}>Forgot password ?</span>
                      </div>
                      <div className="  mx-auto">
                        <button className="w-full mx-auto flex justify-center py-3 uppercase px-4 border text-lg font-semibold rounded-xl text-white bg-[#005F60] border-[#005F60] hover:bg-[#005F79] hover:text-white focus:outline-none focus:border-red-600 focus:shadow-outline-yellow active:bg-red-700 transition duration-150 ease-in-out" type="submit" onClick={this.loginSubmit}>Sign in</button>
                      </div>


                    </form>

                    <div className="leading-5 text-center pt-4">
                      <p className="text-base font-semibold text-[#005F60] ">Don't have an account ?
                        <span className="cursor-pointer text-green-700 font-bold hover:underline hover:text-shine focus:outline-none focus:underline transition ease-in-out duration-150" onClick={() => this.onClickMenu('signup')}> Sign up</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Whole Structure End*/}


        </>

      </>
    )
  }
}
function mapStateToProps(state) {
  const { loggingIn, user, otpSentLogin, registeruser, loading } = state.authentication;
  const { users, authentication } = state;
  return {
    loggingIn,
    otpSentLogin,
    user,
    users,
    registeruser,
    loading,
    authentication
  };
}
export default connect(mapStateToProps)(Login);
// export default NetworkDetector(connect(mapStateToProps)(Login));